import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { FaRedo, FaTimes } from "react-icons/fa";
import { IconeContainer, InfoContainer, TextContainer } from "./style";
import usePermissoes from "hooks/usePermissoes";
import { useEffect, useState } from "react";

interface Props {
  show: boolean;
  handleClose: () => void;
  onClickPular: () => void;
  onClickReprocessar: () => void;
  mensagemErro: string | null;
  idProcesso?: number;
}

export function ModalPularEtapaErro({
  show,
  handleClose,
  onClickPular,
  onClickReprocessar,
  mensagemErro,
  idProcesso,
}: Props) {
  const [showBtnPularEtapa, setShowBtnPularEtapa] = useState<boolean>(false);
  const { listaPermissoes } = usePermissoes();

  useEffect(() => {
    if (
      listaPermissoes.some(
        (item) => item.nome_funcionalidade === "pular_etapa_emplacamento_pr",
      )
    ) {
      setShowBtnPularEtapa(true);
    }
  }, [listaPermissoes]);

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={"Erro"}
      centered
      adaptive
    >
      <InfoContainer>
        <IconeContainer>
          <FaTimes />
        </IconeContainer>
        <TextContainer>
          {!!idProcesso && (
            <span
              style={{ display: "block", fontWeight: 600, marginBottom: 4 }}
            >
              ID Processo: {idProcesso}
            </span>
          )}
          {mensagemErro ?? "Não foi possível executar esta etapa."}
        </TextContainer>
      </InfoContainer>
      <div className="d-flex justify-content-end gap-4 mt-4">
        {showBtnPularEtapa && (
          <PrimaryButton
            style={{ width: "14rem" }}
            outline
            variante="primary"
            onClick={onClickPular}
          >
            Pular etapa
          </PrimaryButton>
        )}
        <PrimaryButton style={{ width: "10rem" }} onClick={onClickReprocessar}>
          Reprocessar <FaRedo />
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
